module.exports = __webpack_public_path__ + "static/media/region_map.5fee4e22.png";